import React, {useEffect} from 'react';
import {ThemeProvider} from 'styled-components';
import {Router} from 'react-router-dom';
import {ToastContainer} from 'react-toastify';

import history from './services/Navigate/history';
import Routes from './routes';
import GlobalStyle from './styles/global';
import theme from './styles/theme';
import '../node_modules/react-toastify/dist/ReactToastify.css';
import WhatsAppButton from "./components/WhatsAppButton";

function App() {

    useEffect(() => {
        const signed = localStorage.getItem('@user_token');
        if (!signed && !(
            window.location.pathname === '/policy-privacy' ||
            window.location.pathname === '/login' ||
            window.location.pathname === '/register' ||
            window.location.pathname === '/' ||
            window.location.pathname === '' ||
            window.location.pathname === '/plans/payment'
        )) {
            window.location.href = '/';
        }
    }, []);

    return (
        <ThemeProvider theme={theme}>
            <Router history={history}>
                <Routes />
            </Router>
            <ToastContainer />
            <WhatsAppButton/>
            <GlobalStyle />
        </ThemeProvider>
    );
}

export default App;
